import React, { useState } from 'react';
import StepShell from './StepShell';
import FieldStack, { ChoiceCard } from './FieldStack';
import { SelectField } from '../../../ui/select-field';
import { InputField } from '../../../ui/input-field';
import { FUEL_OPTIONS } from '../../fixtures';
import { Home, Square, Layers } from 'lucide-react';

const Heating = () => {
  const [fuel, setFuel] = useState('gas');
  const [turnsOn, setTurnsOn] = useState('yes');
  const [hoursPerDay, setHoursPerDay] = useState(6);
  const [monthsPerYear, setMonthsPerYear] = useState(5);
  const [scope, setScope] = useState('all');

  const heatingAllowed = fuel !== 'none';

  return (
    <StepShell
      title='Heating your home'
      description='Only the hours and area used while you are working from home.'>
      <FieldStack label='What fuel do you use for heating?' required>
        <SelectField
          options={FUEL_OPTIONS}
          value={fuel}
          onChange={setFuel}
          placeholder='Pick your heating fuel...'
          className='mb-0'
        />
      </FieldStack>

      {heatingAllowed && (
        <>
          <FieldStack label='Do you turn the heating on while working from home?' required>
            <div className='grid grid-cols-2 gap-2'>
              <ChoiceCard active={turnsOn === 'yes'} label='Yes' onClick={() => setTurnsOn('yes')} />
              <ChoiceCard active={turnsOn === 'no'} label='No' onClick={() => setTurnsOn('no')} />
            </div>
          </FieldStack>

          {turnsOn === 'yes' && (
            <>
              <FieldStack label='On a typical WFH day, how many hours is heating on?' required>
                <InputField
                  type='number'
                  value={hoursPerDay}
                  onChange={(e) => setHoursPerDay(Number(e.target.value))}
                  min={1}
                  max={24}
                  className='mb-0'
                />
              </FieldStack>

              <FieldStack label='How many months per year do you use heating?' required>
                <InputField
                  type='number'
                  value={monthsPerYear}
                  onChange={(e) => setMonthsPerYear(Number(e.target.value))}
                  min={1}
                  max={12}
                  hint='E.g. October through March is 6 months'
                  className='mb-0'
                />
              </FieldStack>

              <FieldStack label='What area do you heat while WFH?' required>
                <div className='space-y-2'>
                  <ChoiceCard
                    active={scope === 'room'}
                    icon={Square}
                    label='Just 1 room'
                    desc='e.g. just your home office'
                    onClick={() => setScope('room')}
                  />
                  <ChoiceCard
                    active={scope === 'multi'}
                    icon={Layers}
                    label='More than 1 room'
                    desc='e.g. office plus kitchen'
                    onClick={() => setScope('multi')}
                  />
                  <ChoiceCard
                    active={scope === 'all'}
                    icon={Home}
                    label='The whole flat or house'
                    onClick={() => setScope('all')}
                  />
                </div>
              </FieldStack>
            </>
          )}
        </>
      )}
    </StepShell>
  );
};

export default Heating;
